import { Global } from '@emotion/react'
import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { CustomRouter } from './router/CustomRouter'

const styles = {
  body: {
    margin: '0',
    padding: '0',
    background: '#f2f2f2',
  },
}

export const App = () => {
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // F5キー押下時はガードする
      if ((event.which || event.keyCode) === 116) {
        event.preventDefault()
      }
    }

    window.addEventListener('keydown', handleKeyPress)

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [])
  useEffect(() => {
    // スマホのタッチ移動をガードする
    const handleTouchMove = (event: TouchEvent) => {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    }

    window.addEventListener('touchmove', handleTouchMove, { passive: false })

    return () => {
      window.removeEventListener('touchmove', handleTouchMove)
    }
  }, [])
  return (
    <BrowserRouter>
      <Global styles={styles} />
      <CustomRouter />
    </BrowserRouter>
  )
}
